module.exports = __webpack_public_path__ + "img/118.3.1bf1bd58.png";